// extracted by mini-css-extract-plugin
module.exports = {"legend":"styles_legend__30cSW","barColoringInfo":"styles_barColoringInfo__21ZLc","firstColoring":"styles_firstColoring__1eG5G","secondColoring":"styles_secondColoring__1eK50"};